
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import CustomFieldMixin from '@/mixins/CustomFieldMixin';
import {genID} from '@/utils/helpers';

@Component
export default class TextField extends mixins(CustomFieldMixin) {
  get label() {
    return this.$attrs.label;
  }

  get attributes() {
    const attrs = {...this.$attrs};
    delete attrs.label;
    return attrs;
  }

  get id() {
    return this.$attrs.id || `input-${genID()}`;
  }
}
